import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../../assets/css/style.css";
import Form from "./Form.js";
import ContentWithImages from "./ContentWithImages.js";
import DoctorBite from "../../DoctorBite.js";
import PatientReviews from "../../PatientReview.js";

import GetInTouch from "../../GetInTouch.js";
import FollowYt from "../../FollowYt.js";
import Counter from "../../../NumCounter.js";
import Breadcrumb from "../../Breadcrum.js";

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
      <Helmet>
      <title>Tympanoplasty Treatment & Surgery Cost in Delhi, India | Doctor, Clinic</title>
      <meta name="description" content="Get expert Tympanoplasty treatment & eardrum repair surgery in Delhi, India by top ENT specialist Dr. Rajesh Bhardwaj. Advanced care, affordable cost & faster recovery." />
      <meta name="keywords" content="Tympanoplasty Delhi, eardrum repair surgery, ENT Delhi, tympanoplasty procedure, hearing restoration, perforated eardrum treatment, tympanoplasty specialist, middle ear surgery" />
      <link rel="canonical" href="https://entdelhi.com/tympanoplasty/" />
      <meta property="og:title" content="Tympanoplasty Treatment & Surgery Cost in Delhi, India | Doctor, Clinic" />
      <meta property="og:description" content="Get expert Tympanoplasty treatment & eardrum repair surgery in Delhi, India by top ENT specialist Dr. Rajesh Bhardwaj. Advanced care, affordable cost & faster recovery." />
      <meta name="robots" content="index, follow" />
    </Helmet>
     <main>
        <Breadcrumb/>
        <Form />  
        <Counter />
        <ContentWithImages />
        <FollowYt />
        <DoctorBite />
        <PatientReviews />
        
        <GetInTouch />
      </main>
    </div>
  );
}
